import { render } from "./PositionsTable.vue?vue&type=template&id=39f107c6&scoped=true"
import script from "./PositionsTable.vue?vue&type=script&lang=js"
export * from "./PositionsTable.vue?vue&type=script&lang=js"

import "./PositionsTable.vue?vue&type=style&index=0&id=39f107c6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39f107c6"]])

export default __exports__